import { trans } from "@mongez/localization";

export function FootprintLegend() {
  return (
    <ul className="mx-auto flex w-max max-w-full flex-wrap items-center justify-center gap-x-5 gap-y-2 rounded-full border border-white/10 bg-white/[0.06] px-5 py-2.5 backdrop-blur-sm">
      <li className="flex items-center gap-2 text-[0.6875rem] text-white/75 sm:text-xs">
        <span className="size-2 shrink-0 rounded-full bg-bright-orange" />
        {trans("globalFootprint.legendManufacturing")}
      </li>
      <li className="flex items-center gap-2 text-[0.6875rem] text-white/75 sm:text-xs">
        <span className="size-2 shrink-0 rounded-full bg-water-blue" />
        {trans("globalFootprint.legendSales")}
      </li>
    </ul>
  );
}
